import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const DirectionArrowShort: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={(+size * 25) / 35}
        viewBox="0 0 35 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M33.778 11.3888L22.9597 0.570551C22.6682 0.289031 22.2778 0.133256 21.8726 0.136777C21.4674 0.140298 21.0798 0.302834 20.7932 0.589377C20.5067 0.875919 20.3441 1.26354 20.3406 1.66876C20.3371 2.07398 20.4929 2.46437 20.7744 2.75584L28.9546 10.936H1.77594C1.36605 10.936 0.972958 11.0988 0.683126 11.3887C0.393294 11.6785 0.230469 12.0716 0.230469 12.4815C0.230469 12.8914 0.393294 13.2845 0.683126 13.5743C0.972958 13.8641 1.36605 14.027 1.77594 14.027H28.9546L20.7744 22.2071C20.6268 22.3497 20.509 22.5202 20.4281 22.7088C20.3471 22.8973 20.3044 23.1001 20.3026 23.3053C20.3009 23.5105 20.34 23.714 20.4177 23.904C20.4954 24.0939 20.6101 24.2665 20.7552 24.4116C20.9003 24.5567 21.0729 24.6714 21.2628 24.7491C21.4528 24.8269 21.6563 24.866 21.8615 24.8642C22.0667 24.8624 22.2695 24.8198 22.458 24.7388C22.6466 24.6578 22.8171 24.54 22.9597 24.3924L33.778 13.5741C34.0677 13.2843 34.2305 12.8913 34.2305 12.4815C34.2305 12.0717 34.0677 11.6787 33.778 11.3888Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)

DirectionArrowShort.displayName = 'DirectionArrowShort'
